import { carregarLocaisDaStore } from '@/integracoes/src-next/catalogos/catalogo-local.vuex'
import { freezeItems } from './freezeItems'

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    pronto: false,
    atualizando: false,
    erro: null,
    sincronizadoEm: null
  },
  getters: {
    todos (state) {
      return state.items
    },
    onlyActive (state) {
      return state.items.filter(i => i.active === true)
    },
    notActive (state) {
      return state.items.filter(i => i.active === false)
    },
    apenasVisiveis (state) {
      const locaisVisiveis = state.items.filter(local => local.visivel === true)
      return locaisVisiveis
    },
    apenasAtivosEVisiveis (state) {
      const locaisAtivos = state.items.filter(local => local.active === true)
      const locaisVisiveis = locaisAtivos.filter(local => local.visivel === true)
      return locaisVisiveis
    },
    // Ativos + visíveis + COM funcionários (totalOfEmployees > 0). Atenção:
    // totalOfEmployees inclui DEMITIDOS, então isto não garante funcionário ativo
    // — serve só de fallback para o getter abaixo enquanto o escopo não resolve.
    apenasAtivosVisiveisComEmpregados (state) {
      return state.items.filter(local => local.active === true && local.visivel === true && typeof local.totalOfEmployees === 'number' && local.totalOfEmployees > 0)
    },
    // Locais com funcionário ATIVO — é o que alimenta o seletor de local da Tela
    // Inicial do Gestor. Deriva de home/gestor/idsLocaisComEmpregadoAtivo (escopo
    // real, sem demitidos). Enquanto o escopo não resolve, cai no fallback por
    // totalOfEmployees (>0) para o dropdown não ficar vazio no carregamento.
    locaisComEmpregadoAtivo (state, getters, rootState) {
      const ids = rootState.home && rootState.home.gestor && rootState.home.gestor.idsLocaisComEmpregadoAtivo
      if (!ids || !ids.length) return getters.apenasAtivosVisiveisComEmpregados
      const idsComAtivo = new Set(ids)
      return state.items.filter(local => local.active === true && local.visivel === true && idsComAtivo.has(local.id))
    }
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    resetItems (state) {
      state.items = []
      state.pronto = false
      state.loading = false
      state.atualizando = false
      state.erro = null
      state.sincronizadoEm = null
    },
    publicarCatalogo (state, { items, ...estado }) {
      if (items !== undefined) state.items = freezeItems(items)
      Object.assign(state, estado)
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems (contexto, payload = {}) {
      await carregarLocaisDaStore(this, payload.fullReload === true)
    }
  }
}
